// extracted by mini-css-extract-plugin
export default {"HeroCardKeyFeatures":"k65Io1lUte","HeroCardKeyFeature":"EawGivBolL"};